// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__a7J2Q","sectionHeaderText":"SectionHeader_sectionHeaderText__fnZhF"};